import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="page">
      <h1 className="page-title">Page not found</h1>
      <p>
        The page you are looking for does not exist. <Link to="/">Go home</Link>.
      </p>
    </div>
  );
}
